import { Button, ButtonVariant } from '@egw/components'
import { useTranslation } from '@egw/i18n'
import { type FC } from 'react'
import { Logger } from '@egw/logger'
import { sendEvent } from '@egw/events'
import { useTransferContextProvider } from '../../context'

const log = new Logger('Account Liquidation Modal')

// TODO ONCE WE MIGRATE TO @EGW/FEATURES-TRANSER WE CAN ADD THE MODAL DRAWER AND STATE MANAGEMENT VIA CONTEXT
export const AccountLiquidation: FC = () => {
  const { t } = useTranslation('features-transfer')

  const { clearTransferErrors, submitForm } = useTransferContextProvider()

  const onClick = async (): Promise<void> => {
    sendEvent('user_liquidateAccount_click', {
      eventSource: 'egWealth',
      category: 'liquidate',
      subCategory: 'intent',
    })
    await submitForm()
      .catch(() => {
        log.error('Error Liquidating Account')
      })
      .finally(() => {
        clearTransferErrors()
      })
  }

  return (
    <div className="flex flex-col">
      <p>{t('liquidation_modal.description')}</p>
      <div className="grow" />
      <div className="flex flex-col gap-4 mt-10">
        <Button
          variant={ButtonVariant.Primary}
          onClick={() => {
            void onClick()
          }}
        >
          {t('liquidation_modal.liquidate_cta')}
        </Button>
        <Button variant={ButtonVariant.Secondary} onClick={clearTransferErrors}>
          {t('liquidation_modal.cancel_cta')}
        </Button>
      </div>
    </div>
  )
}
